import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EwMaTableListService } from './ew-ma-table-list.service';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from 'ew-common-lib';
import { EwTranslateService } from './services/ew-translate.service';


// <ew-webinar-listing-lib></ew-webinar-listing-lib>
// <lib-ew-webinar-analytics></lib-ew-webinar-analytics>
// <lib-ew-ma-attendee-list></lib-ew-ma-attendee-list>

@Component({
  selector: 'lib-ew-ma-table-list',
  template: `
  <ew-webinar-listing-lib></ew-webinar-listing-lib>
  `,
  styles: [
  ]
})
export class EwMaTableListComponent implements OnInit, OnChanges {

  /**
   * @description
   * Event id from parent component.
   */
  @Input() event_id: string = '';
  /**
   * @description
   * Language
   */
  @Input() default_lang: string = 'en';
  // @Output() xyz: any = new EventEmitter();

  constructor(
    private tableListService: EwMaTableListService,
    private ewTranslateService: EwTranslateService,
    public translate: TranslateService,
    private ewloggerService: LoggerService
  ) {
    this.ewloggerService.initLogger();
    // translate.addLangs(['en', 'es']);
  }

  ngOnInit(): void {
    this.tableListService.eventId = this.event_id;
    this.initLanguage();
  }

  initLanguage() {
    this.translate.setDefaultLang(this.default_lang);
    this.translate.use(this.default_lang).subscribe(() => {
      this.ewTranslateService.init();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.default_lang) {
      this.default_lang = changes.default_lang.currentValue;
      this.initLanguage();
    }
    this.tableListService.eventId = this.event_id;
  }

}
